const Main = ({
  nestedScroll,
  nestedPadding,
  maxWidth,
  backdropCl,
  children,
}: {
  nestedScroll?: boolean;
  nestedPadding?: boolean;
  maxWidth?: boolean | string;
  backdropCl?: string;
  children: React.ReactNode;
}) => {
  return (
    <main
      className={`main-content w-full flex-1 min-h-0 flex flex-col min-w-0 relative ${
        nestedScroll ? "overflow-y-hidden" : "overflow-y-auto animate-slide-up"
      } bg-bg-base`}
    >
      {backdropCl ? (
        <div
          className={`w-full shrink-0 min-w-full ${backdropCl}`}
          aria-hidden="true"
        />
      ) : null}

      <div
        className={`main-content-inner flex-1 flex flex-col w-full ${
          maxWidth
            ? `${
                typeof maxWidth === "string"
                  ? maxWidth
                  : "max-w-(--site-main-max-width)"
              } mx-auto px-4`
            : ""
        } ${
          nestedScroll
            ? "min-h-0"
            : nestedPadding
              ? ""
              : "max-sm:pt-5 pt-7 max-sm:pb-8 pb-10"
        }`}
      >
        {children}
      </div>
    </main>
  );
};

export default Main;
